import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { AppState } from '../store';
import { Unauthenticated, Unauthorized, UnsupportedBrowser } from '.';
import { EErrorTypes } from '../data/Constants';
import { useTranslation } from 'react-i18next';
import { TFunction } from 'i18next';
import type { ISupportDetail, ISupportPageProps } from '../../types';
import type { IError } from '../../types/IApiTypes';

//  * Renders a support message for users

const ComponentType = (state: IError, t: TFunction, supportDetail: ISupportDetail | null) => {
  const supportMsg = <h4>{supportDetail ? supportDetail.message : null}</h4>;
  switch (state.type) {
    case EErrorTypes.NotAuthenticated:
      return (
        <>
          <Unauthenticated />
          {supportMsg}
        </>
      );
    case EErrorTypes.NotAuthorized:
      return (
        <>
          <Unauthorized />
          {supportMsg}
        </>
      );
    case EErrorTypes.ContactUS:
      return (
        <h4>
          {supportDetail?.message ? supportDetail.message : t('errorMessages.supportDefault')}
        </h4>
      );
    case EErrorTypes.InvalidConfiguration:
      return (
        <>
          <h4>{state.code === 404 ? state.message : t('errorMessages.invalidConfiguration')}</h4>
          {supportMsg}
        </>
      );
    default:
      return null;
  }
};

export const ErrorPage = ({ type }: ISupportPageProps) => {
  const [supportDetail, setSupportDetail] = useState<{ message: string; url: string } | null>(null);
  const { state } = useLocation();
  const { t } = useTranslation();

  const claimsData = useSelector((st: AppState) => st.claimsData);

  useEffect(() => {
    if (claimsData.claims?.supportDetails) {
      setSupportDetail(claimsData.claims.supportDetails);
    }
  }, [claimsData.claims]);

  if (type) {
    switch (type) {
      case EErrorTypes.Unsupported:
        return <UnsupportedBrowser />;
      case EErrorTypes.NotAuthorized:
        return <Unauthorized />;
      default:
        return null;
    }
  }
  return (
    <div>
      {state && ComponentType(state, t, supportDetail)}
      <a href={supportDetail?.url ? supportDetail.url : ''}>
        {supportDetail?.url ? supportDetail.url : null}
      </a>
    </div>
  );
};
